import { PageConfig } from "@shared/components/page-config";
import useInstructorConfig from "./hooks/useInstructorConfig";

import { AdminHeader } from "@shared/components";
import InstructorApi from "./helpers/instructorApi";
import { useInstructorPage } from "./hooks/useInstructorPage";
import InstructorLanding from "./components/InstructorLanding";
import { FC } from "react";
import NotFound from "pages/404";
import ErrorPage500 from "pages/500";
import SkeletonInstructor from "./components/skeleton/InstructorSkeleton";

const InstructorPage: FC<{ is404?: boolean }> = ({ is404 }) => {
  const { instructor, slug, error, isAdmin, query, mutate } =
    useInstructorPage();
  const instructorPageConfig = useInstructorConfig(instructor, slug);

  if (is404 || error?.error?.code === 404) return <NotFound />;
  else if (error) return <ErrorPage500 />;
  else if (!instructor) return <SkeletonInstructor />;

  return (
    <PageConfig config={instructorPageConfig}>
      {isAdmin ? (
        <AdminHeader
          cacheSetting={{
            withCache: true,
            action: async () => {
              const { slug } = query;
              await InstructorApi.instructorDetail(slug as string, {
                recache: 1,
              }).fetch();
              mutate(undefined, { revalidate: true });
            },
          }}
          editSetting={{
            withEdit: true,
            url: `https://faradars.org/admin/panel/instructors/${instructor.id}/edit`,
            title: "ویرایش مدرس",
          }}
          hasMarkdown
        />
      ) : null}
      <InstructorLanding instructor={instructor} />
    </PageConfig>
  );
};

export default InstructorPage;
